import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { login } from '../../features/search/service/login-service';
import { saveToken } from '../../shared/helpers/localstorage-helper';
import ButtonComponent from '../../components/button/button';
import InputComponent from '../../components/input/input';
import './styles.css';

export default function Login() {
    const navigate = useNavigate();

    const [email, setEmail] = useState<string>('');
    const [password, setPassword] = useState<string>('');
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string>('');

    const handleLogin = async () => {
        if (!email || !password) {
            setError('Por favor, preencha todos os campos');
            return;
        }

        setLoading(true);
        setError('');

        try {
            const response = await login(email, password);
            let isFirstAccess = false;
            
            if(response.userWithoutPassword){
                isFirstAccess = response.userWithoutPassword.firstAccess || 
                                  response.userWithoutPassword.firstAcess;
            }
            
            if (!isFirstAccess && response.userWithoutPassword) {
                saveToken(response.token);
                navigate('/home');
            } else {
                navigate('/reset-pwd', {
                    state: { 
                        email: response.userWithoutPassword.email 
                    }
                });
            }   
        } catch (error) {   
            setError('Erro ao fazer login. Verifique suas credenciais.');
        } finally {
            setLoading(false);
        }
    };

    const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            handleLogin();
        }
    };
    
    return (
        <div className="login-container">
            <img 
                src="../../../assets/logo-inteira.png" 
                alt="Logo delay discounting"  
                className="logo" 
                style={{ width: '300px', height: '200px' }}
            />
            <h1 className="title">Login</h1>
            
            {error && (
                <div className="error-message" style={{ 
                    color: '#991b1b',
                    marginBottom: '12px',
                    padding: '10px 14px',
                    backgroundColor: '#fee2e2',
                    borderRadius: '6px',
                    fontSize: '14px',
                    lineHeight: '1.5',
                    fontFamily: 'Roboto, sans-serif',
                }}>
                    {error}
                </div>
            )}

            <InputComponent 
                id="id-input-email" 
                label="Email" 
                value={email} 
                onChange={(event) => setEmail(event.target.value)}
                onKeyDown={handleKeyDown}
            />
            
            <InputComponent 
                id="id-input-password" 
                type="password" 
                label="Senha" 
                value={password} 
                onChange={(event) => setPassword(event.target.value)}
                onKeyDown={handleKeyDown}
            />
            
            <ButtonComponent 
                label={loading ? 'Entrando...' : 'Acessar'} 
                onClick={handleLogin}
                disabled={loading}
            />
        </div>
    );
}